import { useState } from 'react';
import ModalHeader from '../../modal/components/ModalHeader';

const EditNameModal = ({ title, initialValue, onConfirm, onClose, isLocked }) => {
    const [value, setValue] = useState(initialValue ?? '');

    const handleConfirm = () => {
        if (!value.trim()) return;

        onConfirm(value.trim());
        onClose();
    };

    return (
        <>
            <ModalHeader title={title} onClose={onClose} showBack={false} disableButtons={isLocked} />

            <div className="modal-body edit-name">
                <div className="meal-editor-input">
                    <span className="inline-label">Namn:</span>

                    <input
                        type="text"
                        className="modal-input name-input"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        disabled={isLocked}
                        autoFocus
                    />
                </div>
            </div>

            <div className="modal-footer edit-name">
                <button className="btn-green" onClick={handleConfirm} disabled={isLocked || !value.trim()}>
                    Ändra namn
                </button>

                <button className="marked-border-btn" onClick={onClose} disabled={isLocked}>
                    Avbryt
                </button>
            </div>
        </>
    );
};

export default EditNameModal;
